import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Linkedin, Twitter } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="network-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">Offgrid IT</h3>
            <p className="footer-tagline">Independent Power. Connected Living.</p>
            <p className="footer-description">
              Providing reliable off-grid power, connectivity, security, and IT services
              for rural, remote, and underserved areas across South Africa.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><Link to="/services">Power-Independent IT</Link></li>
              <li><Link to="/services">Internet & Connectivity</Link></li>
              <li><Link to="/services">Security & Surveillance</Link></li>
              <li><Link to="/services">IT Support</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact Us</h4>
            <ul className="footer-contact">
              <li>
                <Mail size={18} />
                <a href="mailto:offgridsolution@gmail.com">offgridsolution@gmail.com</a>
              </li>
              <li>
                <Phone size={18} />
                <a href="tel:+27724603624">+27 72 460 3624</a>
              </li>
              <li>
                <MapPin size={18} />
                <span>South Africa</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Offgrid IT. All rights reserved.</p>
          <p className="footer-service-area">Owned by Mandla Nyoni | Services available in South Africa, Botswana & Namibia</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;